import LPS from '@/views/lps/LPS.vue'

export default [{
  path: '/lps',
  name: "lps",
  component: LPS,
  meta: {
    requiresAuth: true,
  },
}]